import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { toWxMiniProgram } from '../../api/createHttpRequest';
import { Toast, Tabs, Dialog } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';
import utils from '../../utils/utils';

const api = new ApiCore();

const Tools = (props: any) => {

    const [activeKey, setActiveKey] = useState('') // 当前激活 tab 面板
    const [activeLabelKey, setActiveLabelKey] = useState('') // 切换标签
    const [toolData, setToolData] = useState<any>([]) // 首页工具数据
    const [navLabels, setNavLabels] = useState<any>([]) // 标签

    useEffect(() => {
        getLabel();
        getData();
        return () => {
        }
    }, [])

    useEffect(() => {
        setTimeout(() => {
            const scrollDom = document.getElementById('cso_gauge_tool_scroll');
            scrollDom?.scrollTo(0, 0);
        }, 100);
    }, [toolData])

    /**
     * 切换标签
     * @param {*} key 
     */
    const changeLabelTabs = (key: string) => {
        setActiveLabelKey(key)
        getData([key]);
    }

    /**
     * 切换导航
     * @param {*} key 
     */
    const changeTabs = (key: string) => {
        setActiveKey(key)
        setTimeout(() => {
            const scrollDom = document.getElementById('cso_gauge_tool_scroll');
            scrollDom?.scrollTo(0, 0);
        }, 100)
    }

    // 获取标签
    const getLabel = () => {
        let tenantCode = process.env.REACT_APP_ENV == 'production' ? 'TENANT-029' : 'TENANT-024'
        let params: any = {
            tenantCode: tenantCode
        }
        api.getDiseaseLabels(params).then((res: any) => {
            if (res.code == 0) {
                const _data = res.data;
                _data.unshift({
                    code: '',
                    name: '全部'
                });
                setActiveLabelKey(_data[0]?.code);
                setNavLabels(_data || []);
            }
        });
    }

    /**
     * 
     * @param labels 搜索的标签
     */

    const getData = (labels?: Array<any>) => {
        let tenantCode = process.env.REACT_APP_ENV == 'production' ? 'TENANT-029' : 'TENANT-024'
        let params: any = {
            tenantCode: tenantCode,
            labels: labels || []
        }
        api.getNewScalePage(params).then((res: any) => {
            if (res.code == 0) {
                let _resData = res.data || {};
                const scaleListMap = {};
                _resData.scaleList.forEach((item: any) => {
                    if (!scaleListMap[item.categoryCode]) {
                        scaleListMap[item.categoryCode] = [item]
                    } else {
                        scaleListMap[item.categoryCode] = [
                            ...scaleListMap[item.categoryCode],
                            item
                        ]
                    }
                });
                let tooData = _resData.navigation.map((val: any) => {
                    return {
                        ...val,
                        scaleList: scaleListMap[val.code] || []
                    }
                });
                if (_resData.navigation && _resData.navigation.length >= 1) {
                    tooData.unshift({
                        code: '',
                        name: '全部',
                        scaleList: _resData.scaleList
                    });
                }
                if (tooData && tooData.length >= 1) {
                    setActiveKey(tooData[0].code);
                    setToolData(tooData);
                } else {
                    setActiveKey('');
                    setToolData(tooData);
                }
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    }

    // 跳转工具页
    const toTool = async (val: any) => {
        let doctorInfo: any = {};
        let cso_doctor_info = sessionStorage.getItem('cso_doctor_info');
        if (props.doctorInfo && Object.values(props.doctorInfo).length > 0) {
            doctorInfo = props.doctorInfo;
        } else if (cso_doctor_info) {
            doctorInfo = JSON.parse(cso_doctor_info);
        }
        let auditState = doctorInfo?.state;
        let isGuest = false;
        let token = sessionStorage.getItem('token');
        if (token) {
            let tokens = JSON.parse(token);
            if (tokens.isGuest) {
                isGuest = true;
            }
        }
        if (isGuest) {
            // 游客
            const result = await Dialog.confirm({
                content: '您尚未授权登录，请前往授权登录后使用',
            })
            if (result) {
                // 确定
                toWxMiniProgram('/pages/index/index?needLogin=1');
            }
        } else if (!isGuest &&(auditState !== 1 && auditState !== 4)) {
            const result = await Dialog.confirm({
                content: '您尚有个人信息未完善，请先补全个人信息后使用',
            })
            if (result) {
                // 确定
                toWxMiniProgram('/pages/csoComplete/csoComplete');
            } else {
                // 取消
            }
        } else if (val.scaleCode.includes('DRUG') || val.scaleCode.includes('TNM')) {
            props.history.push(`/scale/aggregationScale/${val.scaleCode}?backUrl=${props.history.location.pathname}/`);
        } else {
            props.history.push(`/scale/evaluation/${val.scaleCode}?backUrl=${props.history.location.pathname}/`);
        }
    }

    return (
        <div className={styles.tools_content}>

            <div className={styles.CSO_body_head}>
                <div className={styles.header_content}>
                    {navLabels.length > 0 && <Tabs
                                    className={styles.tabsContent}
                                    activeLineMode='fixed'
                                    onChange={changeLabelTabs}
                                    activeKey={activeLabelKey}
                                    style={{
                                        '--title-font-size': '16px',
                                        '--active-line-height': '4px',
                                        '--fixed-active-line-width': '28px',
                                        '--active-line-color': '#fff',
                                        '--active-title-color': '#fff',
                                    }}>
                                    {
                                        navLabels.map((item: any) => (
                                            <Tabs.Tab title={item.name} key={item.code} >
                                            </Tabs.Tab>
                                        ))
                                    }
                                </Tabs>}
                </div>
                {
                    toolData && toolData.length > 0 && 
                        <div className={styles.tools_nav}>
                            <div className={styles.tools_nav_container}>
                            {
                                toolData.map((item: any, key: number) => (
                                    <div key={key} className={`${styles.nav_item} ${activeKey == item.code ? styles.nav_active : styles.nav_un_active}`} 
                                        onClick={() => { changeTabs(item.code) }}
                                    >
                                        {item.name}
                                    </div>
                                ))
                            }
                            </div>
                        </div>
                }
            </div>

            <div className={styles.tools_content} id="cso_gauge_tool_scroll">
                    {
                        toolData && toolData.filter((val: any) => val.code === activeKey).map((item: any, index: number) => (
                            <div className={styles.toolsModule} id={'anchor' + item.code} key={index}>
                                <div className={styles.toolList}>
                                    {
                                        item.scaleList && item.scaleList.map((v: any, i: number) => (
                                            <div className={`${styles.tool} ${ (item.scaleList.length >= 8) ? styles.tool_1_3 : styles.tool_1_2}`} key={i} onClick={() => toTool(v)}>
                                                <img src={v.icon} alt="" />
                                                <div className={styles.toolName}>{v.title}</div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        ))
                    }
            </div>
        </div>
    )
}

export default withRouter(Tools);